import type { Product } from '@features/products/types/products.types';

/** The product-type key for a provider-sourced service plan. The ONE copy in www. */
export const SMRIQ_PRODUCT_TYPE_KEY = 'smriq_service_plan';

// Reads `product_type.key`, never `product_type_id`: www holds no id->key map.
export const isSmriqProduct = (product?: Product | null): boolean =>
    product?.product_type?.key === SMRIQ_PRODUCT_TYPE_KEY;
